// Mesmas regras da API para anexos de licitações e contratos
export const DOCUMENT_ALLOWED_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'odt', 'ods', 'txt', 'zip', 'rar', 'jpg', 'jpeg', 'png'];
export const DOCUMENT_MAX_SIZE_MB = 25;
export const DOCUMENT_ACCEPT = DOCUMENT_ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(',');

export function validateDocumentFile(file: { name: string; size: number }): string | undefined {
    const extension = file.name.includes('.') ? file.name.split('.').pop()?.toLowerCase() || '' : '';
    if (!DOCUMENT_ALLOWED_EXTENSIONS.includes(extension)) {
        return 'Formato de arquivo não suportado. Use PDF, documentos do Office/LibreOffice, ZIP/RAR ou imagens.';
    }
    if (file.size > DOCUMENT_MAX_SIZE_MB * 1024 * 1024) {
        return `O arquivo deve ter no máximo ${DOCUMENT_MAX_SIZE_MB} MB.`;
    }
    return undefined;
}

export function fileDisplayName(file: { originalFileName?: string; fileName?: string }): string {
    return file.originalFileName || file.fileName || '';
}

// Complemento da confirmação de exclusão de registros com anexos
export function attachmentsRemovalNotice(fileCount: number): string {
    return fileCount > 0 ? ` Os ${fileCount} anexo(s) também serão removidos.` : '';
}

export function formatFileSize(bytes?: number): string {
    if (bytes === undefined || bytes === null || bytes < 0) return '';
    if (bytes < 1024) return `${bytes} B`;
    const kb = bytes / 1024;
    if (kb < 1024) return `${Math.round(kb)} KB`;
    return `${(kb / 1024).toFixed(1).replace('.', ',')} MB`;
}
